import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiGeneratePantherFlowQueryVariables = Types.Exact<{
  input: Types.AIGeneratePantherFlowQueryInput;
}>;

export type RunAiGeneratePantherFlowQuery = {
  aiGeneratePantherFlowQuery: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiGeneratePantherFlowQueryDocument = gql`
  mutation RunAiGeneratePantherFlowQuery($input: AIGeneratePantherFlowQueryInput!) {
    aiGeneratePantherFlowQuery(input: $input) {
      streamName
      streamId
      pinned
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiGeneratePantherFlowQueryMutationFn = Apollo.MutationFunction<
  RunAiGeneratePantherFlowQuery,
  RunAiGeneratePantherFlowQueryVariables
>;

/**
 * __useRunAiGeneratePantherFlowQuery__
 *
 * To run a mutation, you first call `useRunAiGeneratePantherFlowQuery` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiGeneratePantherFlowQuery` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiGeneratePantherFlowQuery, { data, loading, error }] = useRunAiGeneratePantherFlowQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiGeneratePantherFlowQuery(
  baseOptions?: Apollo.MutationHookOptions<
    RunAiGeneratePantherFlowQuery,
    RunAiGeneratePantherFlowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAiGeneratePantherFlowQuery, RunAiGeneratePantherFlowQueryVariables>(
    RunAiGeneratePantherFlowQueryDocument,
    options,
  );
}
export type RunAiGeneratePantherFlowQueryHookResult = ReturnType<
  typeof useRunAiGeneratePantherFlowQuery
>;
export type RunAiGeneratePantherFlowQueryMutationResult =
  Apollo.MutationResult<RunAiGeneratePantherFlowQuery>;
export type RunAiGeneratePantherFlowQueryMutationOptions = Apollo.BaseMutationOptions<
  RunAiGeneratePantherFlowQuery,
  RunAiGeneratePantherFlowQueryVariables
>;
export function mockRunAiGeneratePantherFlowQuery({
  data,
  variables,
  errors,
}: {
  data: RunAiGeneratePantherFlowQuery;
  variables?: RunAiGeneratePantherFlowQueryVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiGeneratePantherFlowQueryDocument, variables },
    result: { data, errors },
  };
}
